import type { Configurator } from '~/models/configurator/configurator.model'
import type { ConfiguratorPoolColor } from '~/models/configurator/configuratorPoolColor.model'
import type { ConfiguratorPoolLine } from '~/models/configurator/configuratorPoolLine.model'
import type { ConfiguratorPoolSize } from '~/models/configurator/configuratorPoolSize.model'
import type { ConfiguratorPoolStair } from '~/models/configurator/configuratorPoolStair.model'

interface UseConfiguratorDataParams {
  configurator: Ref<Configurator>

}
export function useConfiguratorData({
  configurator,
}: UseConfiguratorDataParams) {
  function getUniqueById<T extends { id: number }>(array: T[]): T[] {
    return array.filter((value, index, self) => self.findIndex(v => v.id === value.id) === index)
  }

  const allStairs = computed<ConfiguratorPoolStair[]>(() => {
    return getUniqueById(configurator.value.pools.map(pool => pool.stair))
  })

  const allColors = computed<ConfiguratorPoolColor[]>(() => {
    return getUniqueById(configurator.value.pools.map(pool => pool.color))
  })

  const allSizes = computed<ConfiguratorPoolSize[]>(() => {
    return getUniqueById(configurator.value.pools.map(pool => pool.size))
  })

  const allPoolLines = computed<ConfiguratorPoolLine[]>(() => {
    return getUniqueById(configurator.value.pools.map(pool => pool.poolLine))
  })

  return {
    allPoolLines,
    allStairs,
    allColors,
    allSizes,
  }
}
